import { useQuery } from '@tanstack/react-query';
import { getInterviewById } from '../Services/interviewService';

export const useInterviewById = (interviewId, enabled = true) =>
    useQuery({
        queryKey: ['interview', interviewId],
        queryFn: () => getInterviewById(interviewId),
        enabled: !!interviewId && enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 5 * 60 * 1000,
    });
